import React from "react";
import { Box, Card, CircularProgress, Stack, Typography } from "@mui/material";
import EstadoCompraBadge from "../ui/EstadoCompraBadge";
import {
    formatCantidad,
    formatFecha,
    formatFechaHora,
    formatTexto,
} from "../../utils/formatters";

const SX_CARD = { border: "1px solid #dee2e6", boxShadow: "none", p: { xs: 1.5, sm: 2 } };
// Número en rojo corporativo, como en PedidosN2MobileList
const SX_PEDIDO = { fontWeight: 700, color: "#cc071e", fontSize: { xs: 14, sm: 15 } };
const SX_DATO = { fontSize: { xs: 12, sm: 13 }, color: "#212529" };
const SX_ETIQUETA = { fontWeight: 600, color: "#6c757d" };
const SX_CENTRADO = { display: "flex", justifyContent: "center", py: 4 };
const SX_SPINNER = { color: "#cc071e" };
const SX_VACIO = { color: "#6c757d", textAlign: "center", py: 4 };

const Dato = ({ etiqueta, valor }) => (
    <Typography sx={SX_DATO}>
        <Box component="span" sx={SX_ETIQUETA}>{etiqueta}:</Box> {valor}
    </Typography>
);

const TarjetaCompra = ({ fila }) => (
    <Card sx={SX_CARD}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1} sx={{ mb: 1 }}>
            <Typography sx={SX_PEDIDO}>{formatTexto(fila.numeroPedido)}</Typography>
            <EstadoCompraBadge estado={fila.estado} />
        </Stack>
        <Stack spacing={0.5}>
            <Dato etiqueta="Proveedor" valor={formatTexto(fila.proveedor)} />
            <Dato etiqueta="Fecha entrega" valor={formatFecha(fila.entrega)} />
            <Dato etiqueta="Unidades por puntear" valor={formatCantidad(fila.pendientes)} />
            <Dato etiqueta="Productos por puntear" valor={formatCantidad(fila.productos)} />
            {fila.recepcionado && <Dato etiqueta="Recepcionado por" valor={fila.recepcionado} />}
            {fila.fechaRecepcion && (
                <Dato etiqueta="Fecha recepción" valor={formatFechaHora(fila.fechaRecepcion)} />
            )}
        </Stack>
    </Card>
);

/**
 * Vista móvil del listado de estados de compras: tarjetas con carga y vacío integrados
 */
const EstadosComprasMobileList = ({ rows = [], loading }) => {
    if (rows.length === 0) {
        return loading ? (
            <Box sx={SX_CENTRADO}><CircularProgress sx={SX_SPINNER} /></Box>
        ) : (
            <Typography sx={SX_VACIO}>No hay pedidos de compra pendientes</Typography>
        );
    }
    return (
        <Stack spacing={2}>
            {rows.map((fila) => <TarjetaCompra key={fila.id} fila={fila} />)}
        </Stack>
    );
};

export default React.memo(EstadosComprasMobileList);
